// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NI-z","twoColumnImage":"OI-z"};